import { fbt } from 'fbtee'
import { Users } from 'lucide-react'
import { DashedButton } from '../../components/DashedButton'

export function CrewGuestUpsell({ onClick }: { onClick: () => void }) {
  return (
    <div data-testid="crew-guest-upsell">
      <DashedButton onClick={onClick} className="p-4 text-left">
        <div className="flex items-start gap-3">
          <div className="shrink-0 rounded-full bg-primary/10 p-2 text-primary">
            <Users className="size-5" />
          </div>
          <div className="space-y-1 min-w-0 flex-1">
            <p className="text-base font-semibold">
              {fbt('See who else is going', 'Title of the crew-section upsell card shown to signed-out visitors')}
            </p>
            <p className="text-sm text-muted-foreground">
              <fbt desc="Body of the crew-section upsell card shown to signed-out visitors">
                Log in to see your friends' picks and plan the weekend together.
              </fbt>
            </p>
          </div>
        </div>
      </DashedButton>
    </div>
  )
}
